import { StyleSheet } from "react-native";
import { Dimensions } from "react-native";

// import constants, { colorCorporatiu, colorBotons } from "../Config/constants";

/* Styles for the component Perfil */

const style = StyleSheet.create({
  textPerfil: {
    fontSize: "4.5vh",
    textAlign: "center",
    color: "#fff",
    fontFamily:'Brushway',
    fontWeight: "bolder",
  },
  imageBackground: {
    flex: 1,
    justifyContent: "center",
  },
  nom: {
    textAlign: "center",
    fontWeight: "bolder",
    fontSize: "2.8vh",
    color: "#fff",
    // fontFamily:'Brushway'
  },
  boxNom: {
    flex: 1,
    justifyContent: "center",
    width: "80%",
    maxHeight: "80%",
    borderColor: "#464958",
    borderWidth: 8,
    backgroundColor: "#5cc0ed",
  },
  SecondTitle: {
    color: "#fff",
    fontSize: "3.5vh",
    textAlign: "center",
    fontWeight: "bold",
    fontFamily:'Brushway'
  },
  SecondText: {
    color: "#fff",
    fontSize: "4vh",
    textAlign: "center",
    fontWeight: "bold",
    fontFamily:'Brushway',
  },
  botoItinerari: {
    width: "50%",
    justifyContent: "center",
  },
  itinerariText: {
    fontSize: '1.5rem',
    textAlign: "center",
    fontWeight: "bold",
    width: '100%',
    alignSelf: 'center',
    color : "#fff",
},
itinerariContainer: {
    paddingTop: 5,
    paddingBottom: 5,
    width: "80%",
    textAlign: "center",
    alignSelf: 'center',
    marginTop: 7,
    marginBottom: 7,
    marginLeft: 7,
    marginRight: 7,
    backgroundColor: "#715f4d",
    borderRadius: 10,
},

caixa: {
    maxHeight: "100%",
    width: "100%",
    maxWidth: "100%"
},
image : {
    width: "100%",
    height: "100%",
    resizeMode: "contain",
},
premiImage : {
    height: Dimensions.get('screen').height * 0.1,
    width: Dimensions.get('screen').width * 0.2,
    resizeMode: "contain",
    flexDirection: 'row',
    alignSelf:'center',
},
premiContainer : {
  width:"33.3%",
  alignItems: 'center',
  justifyContent: 'center',
  padding:10,
},

superPremiContainer : {
    width:"65%",
    height: "90%",
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf:'center'
    // padding:10,
},

videoContainer : {
  height: '100%',
  width: '100%',
  backgroundColor: 'black',
  alignSelf: 'center',
  justifyContent: 'center',
},

});

export default style;